import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';


import { SidePanelComponent } from './side-panel.component'

@NgModule({
  declarations: [SidePanelComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, PopupModule
  ],
  exports: [SidePanelComponent],
  providers: [],
})
export class SidePanelModule { }